export default "__VITE_ASSET__01d1dc6e__"